import { string } from "prop-types"
import { Badge } from "@planningcenter/doxy-web"

export const AchStatusBadge = ({ status }) => (
  <Badge
    theme={status === "failed" ? "error" : "warning"}
    size="sm"
    text={status.charAt(0).toUpperCase() + status.slice(1)}
  />
)

AchStatusBadge.propTypes = {
  status: string.isRequired,
}
